<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style src="./style.scss" lang="scss">

</style>

<style>
  .swal2-container {
    z-index: 10000;
  }
</style>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s - DeVo',
  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1);
  },
};
</script>
